import React from 'react';
import { carePlan } from 'res/images';
import CommonBodyCard from 'whealth-core-web/components/CommonBodyCard';
import { titlizeString } from 'whealth-core-web/components/Helper';

function CarePathway(props) {
  const countData = props?.data?.carepathway_counts || [];

  // Build Prescribed, Current, Taken strings from countData
  // Only include pathways that have prescribed > 0
  const carePathwayString = countData
    .filter((item) => item.prescribed > 0)
    .map((item) => `${titlizeString(item.pathway)}(${item.prescribed})`)
    .join(', ');

  const medicationTakenString = countData
    .filter((item) => item.taken > 0)
    .map((item) => `${titlizeString(item.pathway)}(${item.taken})`)
    .join(', ');

  const difference = countData
    .filter((item) => item.current > 0)
    .map((item) => `${titlizeString(item.pathway)}(${item.current})`)
    .join(', ');

    function convertUSTtoIST(ustDate) {
      // Create a new Date object from the UST date string
      if (!ustDate) return "";

      let date = new Date(ustDate);
  
      // Convert UST to IST by adding 5 hours and 30 minutes
      date.setHours(date.getHours() + 5);
      date.setMinutes(date.getMinutes() + 30);
  
      // Define arrays for month and day names
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
      // Get individual date and time components
      let day = date.getDate();
      let month = monthNames[date.getMonth()];
      let year = date.getFullYear();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? 'PM' : 'AM';
  
      // Convert hours from 24-hour to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
  
      // Pad minutes with leading zero if needed
      minutes = minutes < 10 ? '0' + minutes : minutes;
  
      // Format the date and time
      let formattedDate = `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
  
      return formattedDate;
    }

  return (
    <div className='d-md-flex mb-3 bodyCard'>
      <div className='card w-100 no-border'>
        <div className='card-body'>
          <div className='border-bottom pb-2 mb-2'>
            <div className='checkupHead'>Care Pathway</div>
          </div>
          <div className='d-flex checkup-data-part'>
            <div className='checkup-data d-flex flex-column w-100'>
              <CommonBodyCard icon={carePlan} label='Prescribed: ' value={carePathwayString || 'N/A'} />
              <CommonBodyCard icon={carePlan} label='Current: ' value={difference || 'N/A'} />
              <CommonBodyCard icon={carePlan} label='Taken: ' value={medicationTakenString || 'N/A'} />
              <CommonBodyCard icon={carePlan} label='Latest prc prescribed date: ' value={convertUSTtoIST(props?.data?.last_prescribed_prc_at) || 'N/A'} />
              {/* <CommonBodyCard icon={carePlan} label='PRC Count: ' value={`PRC(${prc_count})`} />
              <CommonBodyCard icon={carePlan} label='PRC Taken: ' value={`PRC(${prcTaken})${prcTaken < prc_count ? ' (In Current Care Path)' : ''}`} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarePathway;
